//-- Copyright (c) 2021 TMT Insights Group, LLC
import { initializer as auth } from './slices/authSlice';
export default [auth];
